import React, {useEffect, useRef, useState} from "react";
import { Outlet } from "react-router-dom";
import * as ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import "./style.scss";

export default (props) => {
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes }            = usePopper(referenceElement, popperElement, {

    });
    const [ showContent, setShowContent ]   = useState(false);
    const popperWrapper = useRef(null);
    const BodyClick = (e) => {
        if (popperWrapper.current && !popperWrapper.current.contains(e.target)) 
        {
            setShowContent(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', BodyClick, true);
        return () => {
            document.removeEventListener('click', BodyClick, true);
        }
    },[]);

    return (
        <span className={`three-dots ${props.inline && '--inline'}`} ref={popperWrapper}>
            <span className="three-dots-trigger" ref={setReferenceElement} onClick={(e) => { 
                setShowContent(!showContent) 
            }} >
                <span className="first dots"></span>
                <span className="second dots"></span>
                <span className="third dots"></span>
            </span>
            {
                showContent && 
                <span className="three-dots-content shadow"  ref={setPopperElement} style={styles.popper} >
                    {props.children}
                </span>
            }
        </span>
    )
}